/** Earth radius in km, per spec §8.4. */
export const EARTH_RADIUS_KM = 6371.0088;
/** Great-circle distance in km between two lat/lon points, per spec §8.4. */
export function haversineDistanceKm(a, b) {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const phi1 = toRad(a.lat);
    const phi2 = toRad(b.lat);
    const dPhi = toRad(b.lat - a.lat);
    const dLambda = toRad(b.lon - a.lon);
    const sinDPhi = Math.sin(dPhi / 2);
    const sinDLambda = Math.sin(dLambda / 2);
    const h = sinDPhi * sinDPhi + Math.cos(phi1) * Math.cos(phi2) * sinDLambda * sinDLambda;
    return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h));
}
//# sourceMappingURL=haversine.js.map